export const buildNumber = '20220310.2';
export const version = 'resmed-5';
